module.exports = __webpack_public_path__ + "static/media/Msg ELIMINAR.dfc031ca.svg";